module.exports = "/static/Images/es/Unsatisfied.png";